import { Component, OnInit } from '@angular/core';
import { NotificationService } from '../../../v2-node-api/services/notification.service';
import { DocumentRequestNotificationContent } from '../../interfaces/document-request-content.interface';
import { NotificationBase } from '../../interfaces/notification-base.interface';

@Component({
  selector: 'document-request',
  templateUrl: './document-request.component.html',
  styleUrls: ['./document-request.component.scss']
})
export class DocumentRequestNotificationsComponent implements OnInit, NotificationBase {
  _id: string;
  action: string;
  content: DocumentRequestNotificationContent;
  domain: 'documentRequest';
  seen: boolean;

  constructor(protected notificationService: NotificationService) {
  }

  ngOnInit(): void {
  }

  goTo(documentRequestId) {
    this.notificationService.setSeen(this._id).subscribe(seen => {
      this.seen = true;
    });
  }

}
